(ns manatee.components.media.component
  (:require [manatee.components.question-text :as question-text]
            [rothko.audio.mini-player.component :refer [mini-player]]
            [rothko.media.component :as rothko-media]))

(defn component
  [{:keys [question] :as item}]
  [:<>
   (when (:audio-url question)
     [mini-player {:appearance #{:align-left}
                   :src (:audio-url question)
                   :label "Listen to the question"}])
   (when (:image-urls question)
     [:div
      [question-text/question-text item]
      (for [image-url (:image-urls question)]
        ^{:key image-url}
        [rothko-media/media {:type :image
                             :src image-url}])])])
